export const selectedOptions = ({ search }) => search;
